<dt-modal-content (closeClick)="close()" [contentPadding]="false" [flexContent]="true">
  <ng-template #title i18n>Benutzerdetails</ng-template>
  <ng-template #content>
    <mat-tab-group dynamicHeight>
      <mat-tab label="Eigenschaften" i18n-label>
        <dt-user-properties [user]="user" (isBusy)="propertiesIsBusy = $event" (userDeleted)="onUserDeleted()"></dt-user-properties>
      </mat-tab>
      <mat-tab label="Projekte" [disabled]="propertiesIsBusy" i18n-label>
        <dt-user-projects [user]="user"></dt-user-projects>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</dt-modal-content>
